import { render, staticRenderFns } from "./PrintPriceProduct.vue?vue&type=template&id=a673fcd8&scoped=true&"
import script from "./PrintPriceProduct.vue?vue&type=script&lang=js&"
export * from "./PrintPriceProduct.vue?vue&type=script&lang=js&"
import style0 from "./PrintPriceProduct.vue?vue&type=style&index=0&id=a673fcd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a673fcd8",
  null
  
)

export default component.exports